import {Injectable, signal, WritableSignal} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {MatSnackBarRef} from '@angular/material/snack-bar';

export interface WarningMessageParams {
  message: string;
  dismissDelay?: number;
}

export interface IWarningStateService {
  warningMessage$: Observable<WarningMessageParams>;
  showWarning(message: string): void;
}

@Injectable({
  providedIn: 'root'
})
export class WarningStateService implements IWarningStateService{

  constructor() { }

  private warning$$ = new Subject<WarningMessageParams>();
  warningMessage$: Observable<WarningMessageParams> = this.warning$$.asObservable();

  private _snackBarRef: WritableSignal<MatSnackBarRef<any> | undefined> = signal(undefined);
  readonly snackBarRef = this._snackBarRef.asReadonly()



  showWarning(message: string, dismissDelay = 3000) {
    const warningMessage: WarningMessageParams = {message, dismissDelay: dismissDelay};
    this.warning$$.next(warningMessage);
  }

  setSnackBarRef(snackBarRef: MatSnackBarRef<any>) {
    this._snackBarRef.set(snackBarRef);
  }
}
